import { useNavigate } from 'react-router-dom'
import { getUrlParams } from '../../../../utils/helpers/common'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import * as actions from '../../../../store/slices'
import { supportProgramTypes } from '../../../../constants/support-programs'

const useLiverForeverPreview = () => {
  const params = getUrlParams()
  const navigate = useNavigate()
  const supportProgram = supportProgramTypes['liver-forever-program']

  const uploadDocumentData = supportProgram?.steps?.find(
    (step) => step?.id === 'documents',
  )

  const { ftuDocumentsWithoutVisit: documents } = useSelector(
    (state) => state.records,
  )
  const { patientDetails } = useSelector((state) => state.auth)
  const dispatch = useDispatch()

  useEffect(() => {
    fetchDocuments()
  }, [])

  const fetchDocuments = () => {
    const payload = {
      patient_id: patientDetails?.data?.patient_id,
      report_type: uploadDocumentData?.upload_report_type,
    }
    new Promise((resolve, reject) => {
      dispatch(
        actions.fetchLiverFTUDocumentsWithoutVisitRequest({
          payload,
          resolve,
          reject,
        }),
      )
    })
  }

  const onUploadSuccess = () => {
    fetchDocuments()
  }

  const handleBackToCareProgramClick = () => {
    navigate('/care-plans/liver-forever-program')
  }

  return {
    supportProgram,
    uploadDocumentData,
    documents,
    onUploadSuccess,
    handleBackToCareProgramClick,
  }
}

export default useLiverForeverPreview
